<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings


</style>


<script>

    // import $ from "jquery";

    export default {
        name: "BlockWebformNewsletter"
    }

</script>
